/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/

import { icon_cast_connected } from './hardware/cast_connected.icon';
import { icon_cast } from './hardware/cast.icon';
import { icon_desktop_windows } from './hardware/desktop_windows.icon';
import { icon_computer } from './hardware/computer.icon';
import { icon_desktop_mac } from './hardware/desktop_mac.icon';
import { icon_developer_board } from './hardware/developer_board.icon';
import { icon_device_hub } from './hardware/device_hub.icon';
import { icon_dock } from './hardware/dock.icon';
import { icon_gamepad } from './hardware/gamepad.icon';
import { icon_devices_other } from './hardware/devices_other.icon';
import { icon_headset_mic } from './hardware/headset_mic.icon';
import { icon_keyboard_arrow_down } from './hardware/keyboard_arrow_down.icon';
import { icon_headset } from './hardware/headset.icon';
import { icon_keyboard } from './hardware/keyboard.icon';
import { icon_keyboard_arrow_left } from './hardware/keyboard_arrow_left.icon';
import { icon_keyboard_arrow_right } from './hardware/keyboard_arrow_right.icon';
import { icon_keyboard_capslock } from './hardware/keyboard_capslock.icon';
import { icon_keyboard_arrow_up } from './hardware/keyboard_arrow_up.icon';
import { icon_keyboard_backspace } from './hardware/keyboard_backspace.icon';
import { icon_keyboard_return } from './hardware/keyboard_return.icon';
import { icon_keyboard_tab } from './hardware/keyboard_tab.icon';
import { icon_keyboard_hide } from './hardware/keyboard_hide.icon';
import { icon_laptop_mac } from './hardware/laptop_mac.icon';
import { icon_laptop_windows } from './hardware/laptop_windows.icon';
import { icon_mouse } from './hardware/mouse.icon';
import { icon_memory } from './hardware/memory.icon';
import { icon_phone_android } from './hardware/phone_android.icon';
import { icon_phone_iphone } from './hardware/phone_iphone.icon';
import { icon_phonelink } from './hardware/phonelink.icon';
import { icon_keyboard_voice } from './hardware/keyboard_voice.icon';
import { icon_power_input } from './hardware/power_input.icon';
import { icon_scanner } from './hardware/scanner.icon';
import { icon_router } from './hardware/router.icon';
import { icon_security } from './hardware/security.icon';
import { icon_sim_card } from './hardware/sim_card.icon';
import { icon_smartphone } from './hardware/smartphone.icon';
import { icon_phonelink_off } from './hardware/phonelink_off.icon';
import { icon_speaker_group } from './hardware/speaker_group.icon';
import { icon_tablet } from './hardware/tablet.icon';
import { icon_speaker } from './hardware/speaker.icon';
import { icon_tablet_android } from './hardware/tablet_android.icon';
import { icon_tablet_mac } from './hardware/tablet_mac.icon';
import { icon_tv } from './hardware/tv.icon';
import { icon_toys } from './hardware/toys.icon';
import { icon_videogame_asset } from './hardware/videogame_asset.icon';
import { icon_watch } from './hardware/watch.icon';
import { icon_laptop } from './hardware/laptop.icon';
import { icon_laptop_chromebook } from './hardware/laptop_chromebook.icon';
var icons = {
  "cast_connected" : icon_cast_connected,
"cast" : icon_cast,
"desktop_windows" : icon_desktop_windows,
"computer" : icon_computer,
"desktop_mac" : icon_desktop_mac,
"developer_board" : icon_developer_board,
"device_hub" : icon_device_hub,
"dock" : icon_dock,
"gamepad" : icon_gamepad,
"devices_other" : icon_devices_other,
"headset_mic" : icon_headset_mic,
"keyboard_arrow_down" : icon_keyboard_arrow_down,
"headset" : icon_headset,
"keyboard" : icon_keyboard,
"keyboard_arrow_left" : icon_keyboard_arrow_left,
"keyboard_arrow_right" : icon_keyboard_arrow_right,
"keyboard_capslock" : icon_keyboard_capslock,
"keyboard_arrow_up" : icon_keyboard_arrow_up,
"keyboard_backspace" : icon_keyboard_backspace,
"keyboard_return" : icon_keyboard_return,
"keyboard_tab" : icon_keyboard_tab,
"keyboard_hide" : icon_keyboard_hide,
"laptop_mac" : icon_laptop_mac,
"laptop_windows" : icon_laptop_windows,
"mouse" : icon_mouse,
"memory" : icon_memory,
"phone_android" : icon_phone_android,
"phone_iphone" : icon_phone_iphone,
"phonelink" : icon_phonelink,
"keyboard_voice" : icon_keyboard_voice,
"power_input" : icon_power_input,
"scanner" : icon_scanner,
"router" : icon_router,
"security" : icon_security,
"sim_card" : icon_sim_card,
"smartphone" : icon_smartphone,
"phonelink_off" : icon_phonelink_off,
"speaker_group" : icon_speaker_group,
"tablet" : icon_tablet,
"speaker" : icon_speaker,
"tablet_android" : icon_tablet_android,
"tablet_mac" : icon_tablet_mac,
"tv" : icon_tv,
"toys" : icon_toys,
"videogame_asset" : icon_videogame_asset,
"watch" : icon_watch,
"laptop" : icon_laptop,
"laptop_chromebook" : icon_laptop_chromebook,
};
export { icons };
